import React, {useState, useEffect} from 'react';
import Paper from "@material-ui/core/Paper";
import TablePagination from "@mui/material/TablePagination";
import Table from "react-bootstrap/Table";
import {Box} from "@material-ui/core";
import Grid from "@mui/system/Unstable_Grid/Grid";

import {useToast} from '../Context/ToastContext';
import {API_URL} from '../utils/constants';
import jwtInterceptor from '../service/jwtInterceptor';
import {Helmet} from 'react-helmet';
import TransactionFilterCard from '../component/TransactionFilterCard';


const fontWeightTitle = {
    fontWeight: "600"
};

const tableStyles = {
    th: {
        borderBottom: "1px solid rgba(224, 224, 224, 1)",
        backgroundColor: "#fff",
        fontWeight: 500,
        fontSize: "0.875rem",
        color: "rgba(0, 0, 0, 0.87)",
        padding: "17px"
    },
    td: {
        fontSize: "0.875rem",
        color: "rgba(0, 0, 0, 0.87)",
        borderBottom: "1px solid rgba(224, 224, 224, 1)",
        padding: "17px"
    },
    tr: {
        '&:hover': {
            backgroundColor: '#f5f5f5'
        }
    }
};

const TransactionContainer = () => {
    const DEFAULT_PER_PAGE = 10;
    const DEFAULT_PAGE = 0;

    const toaster = useToast();

    const [total, setTotal] = useState(0);
    const [dataTable, setDataTable] = useState([]);
    const [page, setPage] = useState(DEFAULT_PAGE);
    const [rowsPerPage, setRowsPerPage] = useState(DEFAULT_PER_PAGE);
    const [loading, setLoading] = useState(true);

    const [filters, setFilters] = useState({
        transactionNumber: "",
        term: "",
        municipality: "",
        canton: "",
        address: "",
        sellers: "",
        buyers: "",
        dateRange: {
            startDate: null,
            endDate: null,
        },
        priceRange: {
            minPrice: "",
            maxPrice: "",
        },
    });

    const columns = [
        {accessor: "official_id", show: "N° Transaction"},
        {accessor: "address", show: "Adresse"},
        {accessor: "city", show: "Commune"},
        {accessor: "sellers", show: "Vendeurs"},
        {accessor: "buyers", show: "Acheteurs"},
        {accessor: "price", show: "Prix"},
        {accessor: "details", show: "Détails"},
        {accessor: "date", show: "Date de transaction"},
        {accessor: "land_information", show: "Information"},
    ];

    const handleChangePage = (event, newPage) => {
        setLoading(true);
        setPage(newPage);
        getData(rowsPerPage, newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setLoading(true);
        setRowsPerPage(parseInt(event.target.value));
        getData(event.target.value, page);
    };

    const getData = async (perPage, currentPage) => {
        try {
            const response = await jwtInterceptor.post(
                `${API_URL}/transaction/search`,
                {
                    ...filters,
                    size: perPage,
                    page: currentPage
                }
            );

            setTotal(response.data.data.total);
            setDataTable(response.data.data.results);
        } catch (error) {
            toaster.notifyError(error.message);
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = (filterParam) => {
        setFilters({...filterParam, isEmpty: false});
        searchfn({...filterParam, isEmpty: false});
    };

    const searchfn = async (filter) => {
        setLoading(true);
        const currentPage = filter.page !== undefined ? filter.page : 0;
        setFilters(filter);
        setPage(currentPage);

        try {
            const response = await jwtInterceptor.post(
                `${API_URL}/transaction/search`,
                {
                    ...filter,
                    size: rowsPerPage,
                    page: currentPage,
                    transactionNumber: filter.transactionNumber || "",
                    city: filter.city || "",
                    address: filter.address || "",
                    sellers: filter.sellers || "",
                    buyers: filter.buyers || "",
                    startDate: filter.startDate || null,
                    endDate: filter.endDate || null,
                    minPrice: filter.minPrice || "",
                    maxPrice: filter.maxPrice || ""
                }
            );

            setTotal(response.data.data.total);
            setDataTable(response.data.data.results);
        } catch (error) {
            toaster.notifyError(error.message);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        getData(rowsPerPage, page);
    }, []);

    return (
        <Box className="my-4 w-100 px-4">
            <Helmet>
                <title>Transactions - Mixdata</title>
            </Helmet>
            <Grid container spacing={2}>
                <Grid
                    className="filters shadow-none"
                    xl={3}
                    lg={3}
                    md={4}
                    sm={12}
                    xs={12}
                >
                    <Paper className="shadow-none">
                        <TransactionFilterCard handleSearch={handleSearch} initialFilters={filters}/>
                    </Paper>
                </Grid>
                <Grid xl={9} lg={9} md={8} sm={12} xs={12}>
                    <Box className="mb-3">
                        <h3 style={{...fontWeightTitle}}>Transactions</h3>
                    </Box>
                    <Box className="listtransactions h-auto w-100 m-0 position-relative z-index">
                        <Paper
                            className="py-4 px-4 rounded shadow-none App-container m-0 overflow-hidden position-relative z-index">
                            <Box className="overflow-auto">
                                <Table>
                                    <thead
                                        style={{
                                            background: "#eeeeee",
                                            borderBottom: "2px #DEE2E6 solid",
                                            fontWeight: "normal",
                                            color: "#363636",
                                            marginBottom: "5px",
                                        }}
                                    >
                                    <tr className="transactions-table">
                                        {columns.map((field) => (
                                            <th key={field.accessor} style={tableStyles.th}>{field.show}</th>
                                        ))}
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {loading ? (
                                        <tr>
                                            <td colSpan={columns.length} align="center" style={tableStyles.td}>
                                                Chargement en cours...
                                            </td>
                                        </tr>
                                    ) : dataTable.length > 0 ? (
                                        dataTable.map((transaction) => (
                                            <tr
                                                key={transaction._id}
                                                style={tableStyles.tr}
                                            >
                                                <td style={tableStyles.td}>{transaction._source.official_id}</td>
                                                <td style={tableStyles.td}>{transaction._source.address}</td>
                                                <td style={tableStyles.td}>{transaction._source.city}</td>
                                                <td style={tableStyles.td}>{transaction._source.sellers}</td>
                                                <td style={tableStyles.td}>{transaction._source.buyers}</td>
                                                <td style={tableStyles.td}>{transaction._source.price}</td>
                                                <td style={tableStyles.td}>{transaction._source.details}</td>
                                                <td style={tableStyles.td}>{transaction._source.date}</td>
                                                <td style={tableStyles.td}>{transaction._source.land_information}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td
                                                colSpan={columns.length}
                                                align="center"
                                                style={tableStyles.td}
                                            >
                                                Aucune transaction trouvée
                                            </td>
                                        </tr>
                                    )}
                                    </tbody>
                                </Table>
                            </Box>
                            <TablePagination
                                component="div"
                                count={total}
                                page={page}
                                onPageChange={handleChangePage}
                                rowsPerPage={rowsPerPage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                rowsPerPageOptions={[10, 25, 50]}
                                labelRowsPerPage="Lignes par page"
                                labelDisplayedRows={({from, to, count}) => `${from}-${to} sur ${count}`}
                                sx={{
                                    '.MuiTablePagination-select': {
                                        marginRight: '32px'
                                    }
                                }}
                            />
                        </Paper>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default TransactionContainer; 